import React from 'react';

import { useFormikContext } from 'formik';
import { useTranslation } from 'i18n/hooks';
import { Checkbox, Label } from 'revibe-ui';
import { SpacedContainer } from 'revibe-ui';

import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';

import { PriceFilter } from './PriceFilter';
import { SearchFilter } from './SearchFilter';
import { SexFilter } from './SexFilter';
import { SizeFilter } from './SizeFilter';
import { SortFilter } from './SortFilter';
import { MarketplaceAPI } from 'revibe-api';

export const ItemsFiltersDesktop = () => {
  const { tu } = useTranslation('shop.filters');
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();
  return (
    <form>
      <SpacedContainer>
        <SearchFilter />
        <SexFilter />
        <SortFilter />
        <SizeFilter />
        <PriceFilter />
        <div className="flex items-center space-x-2">
          <Checkbox
            id="only-preorder"
            checked={values[ITEM_FILTERS.IN_PREORDER]}
            onCheckedChange={() => {
              setFieldValue(
                ITEM_FILTERS.IN_PREORDER,
                !values[ITEM_FILTERS.IN_PREORDER]
              );
              handleSubmit();
            }}
          />
          <Label htmlFor="only-preorder">{tu('only-preorder', 'shop')}</Label>
        </div>
      </SpacedContainer>
    </form>
  );
};
